module.exports = __webpack_public_path__ + "img/property-location.fa604f33.svg";